<template>
  <div class="static-layout">
    <top-bar />
    <div class="static-layout__content">
      <router-view />
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/common/TopBar";

export default {
  components: {
    "top-bar": TopBar
  }
};
</script>

<style scoped>
.static-layout {
  height: 100vh;
  box-sizing: border-box;
}

.static-layout__content {
  height: 90vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
